<template>
  <div class="overflow-auto">
    <b-pagination
      v-on:input="setCurrentPage($event)"
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="items-list"
      pills 
      align="center"
    ></b-pagination>
    <!-- <p class="mt-3">Current Page: {{ currentPage }}</p> -->

  </div>
</template>

<script>
  export default {
    data() {
      return {
        perPage: 1,
        currentPage: 1
      }
    },
    props: {
      empresa: {}
    },
    computed: {
      rows() {
        return this.$store.getters['painel/getTotalPages']
      }
    },
    methods: {
      setCurrentPage (newPage) {
        this.$store.commit('painel/setCurrentPage', { page: newPage })

        this.$store.dispatch('painel/getAgendamentos', { data: this.empresa })
      }

    }
  }
</script>